import { ServiceHandler } from '../../../utils/api.utils';
import type {
  ProactiveMessage,
  ProactiveMessagePatch,
  ProactiveMessagesResponse,
} from '../types';

export const getProactiveMessages = ServiceHandler<
  unknown,
  ProactiveMessagesResponse
>({
  url: '/api/chat-agent/v1/proactive-messages',
});

/**
 * Mark a single proactive message read or dismissed so the backend stops
 * returning it as unread (and the poller stops re-surfacing it). Call as
 * `markProactiveMessage(id, { data: { status } })`.
 */
export const markProactiveMessage = ServiceHandler<
  ProactiveMessagePatch,
  ProactiveMessage
>({
  url: '/api/chat-agent/v1/proactive-messages/:id',
  method: 'patch',
});
